import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const StudentTeacherService = {
    ListStudent(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.STUDENT_TEACHER}/student`, null, wait).then((data) => {
            callback(data);
        });
    },
    ByStudent(id, callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.STUDENT_TEACHER}/student/` + id, null, wait).then((data) => {
            callback(data);
        });
    },
    ByTeacher(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.STUDENT_TEACHER}/teacher`, null, wait).then((data) => {
            callback(data);
        });
    },
}; 